import $ from 'jquery';
import 'summernote';

export default function (context) {

    var ui = $.summernote.ui;
    var options = context.options;
    var self = this;
  
    /*this.events = {
        'summernote.mousedown': function (we, e) {
            if (self.update(e.target)) {
                e.preventDefault();
            }
        },
        'summernote.change summernote.dialog.shown': function () {
          self.hide();
        },
        'summernote.focusout': function (we, e) {
            self.hide();
        }
    };*/

    this.shouldInitialize = function () {
        return options.popover.mimage && options.popover.mimage.length;
    };
    
    this.initialize = function () {
      
        this.$popover = ui.popover({
            className: 'note-image-popover'
        }).render().appendTo('body');

        var $content = this.$popover.find('.popover-content');
        context.invoke('buttons.build', $content, options.popover.mimage);
    };
    
    this.destroy = function () {
        this.$popover.remove();
    };
    
    this.update = function (target) {
        // console.log('my image popover is update...');
        var isImg = target && target.nodeName.toUpperCase() === 'IMG';
      
        if (isImg && $(target).closest('.article-item-unit').length <= 0) {
          // console.log('my image popover is show');
            var pos = $(target).offset();
            this.$popover.css({
                display: 'block',
                left: pos.left,
                top: pos.top
            });
        } else {
          // console.log('my image popover is show');
            this.hide();
        }
    };
    
    this.hide = function () {
        this.$popover.hide();
    };
}
